import { footerBg, webLogoFooter } from "Assets";
import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaPhoneAlt,
} from "react-icons/fa";
import { FaLocationDot } from "react-icons/fa6";
import { MdOutlineEmail } from "react-icons/md";
import { Link } from "react-router-dom";
const Footer = () => {
  return (
    <footer
      className="xs-footer-sec"
      style={{ backgroundImage: `url(${footerBg})` }}
    >
      <div className="container">
        <div className="footer-item">
          <div className="row">
            <div className="col-md-4 col-sm-6">
              <div className="widgets">
                <div className="footer-logo">
                  <Link to="/">
                    <img src={webLogoFooter} alt="Footer Logo" />
                  </Link>
                </div>
                <p>
                  With CrickSage Experience The Thrill Of Cricket With Our
                  Efficient Cricket Turf & Ground Booking System, Easy Scoring
                  App, Team Management, Wining Exciting Prizes & Many More
                  Exciting Features.
                </p>
                <ul className="social-media-footer">
                  <li>
                    <a
                      href="https://www.facebook.com/profile.php?id=61564130858773"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaFacebookF />
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.instagram.com/cricksage_app/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaInstagram />
                    </a>
                  </li>

                  <li>
                    <a
                      href="https://www.linkedin.com/company/cricksage"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaLinkedinIn />
                    </a>
                  </li>
                </ul>
              </div>
            </div>

            <div className="col-md-2">
              <div className="widgets pdleft30 cmpny">
                <h3 className="widget-title">Useful Links</h3>
                <ul>
                  <li>
                    <Link to="/">Home</Link>
                  </li>
                  <li>
                    <Link to="/about">About</Link>
                  </li>

                  <li>
                    <Link to="/">Blog</Link>
                  </li>
                  <li>
                    <Link to="/contact-us">Contact Us</Link>
                  </li>
                </ul>
              </div>
            </div>

            <div className="col-md-3">
              <div className="widgets pdleft40">
                <h3 className="widget-title">Legal</h3>
                <ul>
                  <li>
                    <Link to="/faq">Faq’s</Link>
                  </li>
                  <li>
                    <Link to="/privacy-policy">Privacy Policy</Link>
                  </li>
                  <li>
                    <Link to="/term-condition">Terms And Conditions</Link>
                  </li>
                </ul>
              </div>
            </div>

            <div className="col-md-3">
              <div className="widgets cmpny">
                <h3 className="widget-title">Contact Us</h3>
                <ul className="footer-contact-list social">
                  {/* <li>
                    <a href="#">
                      <FaLocationDot />
                      202-Krishna Tower, Pipliyahana, Indore (MP), India
                    </a>
                  </li> */}
                  <li>
                    <a href="mailto:info@cricksage.com">
                      <MdOutlineEmail />
                      info@cricksage.com
                    </a>
                  </li>
                  {/* <li>
                    <a href="tel:+919109006676">
                      <FaPhoneAlt />
                      +91 9109006676
                    </a>
                  </li> */}
                </ul>
              </div>
            </div>

            <div className="col-md-12 text-center">
              <div className="bottom-bar">
                <p className="Cricbooks">
                  © Copyright 2024 Zeeweesoft All rights reserved
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
